// src/composables/useDate.js
export function useDate() {
  function dateFromString(date) {
    let dateTimeParts = date.split(/[- :]/) // array con: año, mes, día, hora, min, seg
    dateTimeParts[1]-- // mes base 0
    return new Date(...dateTimeParts)
  }

  function date2Es(date, time) {
    if (typeof date === "string") date = dateFromString(date)
    if (time) return date.toLocaleString("es-AR")
    return date.toLocaleDateString("es-AR")
  }

  function esCalendar2Sql(date) {
    let sqlDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    return `${sqlDate} ${date.getHours()}:${date.getMinutes()}`
  }

  // Para filtros "Hasta": fija la hora a 23:59
  function esCalendar2SqlFechaHasta(date) {
    let sqlDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    return `${sqlDate} 23:59`
  }

  function actualDate() {
    let fechaYhoraActual = new Date()
    let fecha = fechaYhoraActual.toISOString().slice(0, 10).replace("T", " ")
    let dia = new Date(fechaYhoraActual)
    let hora = dia.getHours() + ":" + dia.getMinutes() + ":" + dia.getSeconds()
    return fecha + " " + hora
  }

  function generateDate(data) {
    if (typeof data === "string") data = new Date(data)
    if (data === null) return ""
    let fecha = data.toISOString().slice(0, 10).replace("T", " ")
    let dia = new Date(data)
    let hora = dia.getHours() + ":" + dia.getMinutes() + ":" + dia.getSeconds()
    return fecha + " " + hora
  }

  return {
    dateFromString,
    date2Es,
    esCalendar2Sql,
    esCalendar2SqlFechaHasta,
    actualDate,
    generateDate,
  }
}